import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref, computed, onMounted } from "vue";

import Paginator from "primevue/paginator";
import TopCampaignsPanel from "@/entities/campaigns/panels/TopListCampaignsPanel.vue";
import CampaignsFilterForm from "@/entities/campaigns/forms/CampaignsFilterForm.vue";
import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import EmptyTableMessage from "@/entities/segments/EmptyTableMessage.vue";
import CampaignsTable from "@/entities/campaigns/CampaignsTable.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";

import { useCampaignStore, CampaignsParams } from "@/store/campaigns/campaigns";
import { useCampaignsDictionariesStore } from "@/store/dictionaries/campaigns";
import { useAuthStore } from "@/store/auth/login";
import { FilterForm } from "@/services/campaigns/utils";
import { rowsCount } from "@/services/utils/Pagination";
import { setCampaignParamsByFilter } from "@/services/campaigns/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCampaignsPage',
  setup(__props) {

const store = useCampaignStore();
const campaignsDictionariesStore = useCampaignsDictionariesStore();
const isArchiveEnabled = ref(false);
const isFilterEnabled = ref(false);
const isFilterSetted = ref(false);
const isLoading = ref(false);
const authStore = useAuthStore();
const tableDisplaySettings = ref({
  first: 0,
  orderField: "",
  isArchived: false,
  filter: {} as FilterForm,
  commonFilter: "",
});

const filteredCampaigns = computed(() => {
  return store.campaignsList;
});

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions([
    "campaign:read",
    "campaign:edit",
    "system:read",
    "system:edit",
  ]);
});

onMounted(() => {
  if (isDenied.value) return;
  loadData();
});

const loadData = () => {
  isLoading.value = true;
  campaignsDictionariesStore.getStates().then(() => {
    tableDisplaySettings.value.stateIdIn =
      campaignsDictionariesStore.defaultStates;
    updateCampaignsList();
  });
  campaignsDictionariesStore.getSegmentsStates();
};

const activeFirstFromStore = computed(() => store.activeFirst);

const updateCampaignsList = () => {
  let isEnded = false;

  setTimeout(() => {
    if (!isEnded) {
      isLoading.value = true;
    }
  }, 200);

  const params: CampaignsParams = {
    page: tableDisplaySettings.value.first + 1,
    per_page: rowsCount(46, 20),
  };

  setCampaignParamsByFilter(params, tableDisplaySettings.value);

  store.getCampaigns(params).finally(() => {
    isLoading.value = false;
    isEnded = true;
  });
};
const toggleArchive = () => {
  isArchiveEnabled.value = !isArchiveEnabled.value;
  tableDisplaySettings.value.first = 0;
  if (isArchiveEnabled.value) tableDisplaySettings.value.isArchived = true;
  else tableDisplaySettings.value.isArchived = false;
  updateCampaignsList();
};

const setCommonFilter = (filter: string) => {
  tableDisplaySettings.value.commonFilter = filter;
  updateCampaignsList();
};

const setFilter = (filter: object, isSetted: boolean) => {
  tableDisplaySettings.value.filter = filter;
  isFilterSetted.value = isSetted;
  updateCampaignsList();
};

const sortTable = (order_by: string) => {
  tableDisplaySettings.value.orderField = order_by;
  updateCampaignsList();
};

let resizeTimeout: number;

window.addEventListener("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(updateCampaignsList, 200);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsWithTableLayout, null, {
    body: _withCtx(() => [
      _createVNode(HandlerAccessDenied, { "is-denied": isDenied.value }, {
        default: _withCtx(() => [
          _createVNode(CampaignsFilterForm, {
            isFilterEnabled: isFilterEnabled.value,
            onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value)),
            onSetFilter: setFilter
          }, null, 8, ["isFilterEnabled"]),
          _createVNode(TopCampaignsPanel, {
            isArchiveEnabled: isArchiveEnabled.value,
            isFilterEnabled: isFilterEnabled.value,
            isFilterSetted: isFilterSetted.value,
            onToggleArchive: toggleArchive,
            onSetCommonFilter: setCommonFilter,
            onToggleFilter: _cache[1] || (_cache[1] = ($event: any) => (isFilterEnabled.value = !isFilterEnabled.value))
          }, null, 8, ["isArchiveEnabled", "isFilterEnabled", "isFilterSetted"]),
          _createElementVNode("div", {
            id: "table-container",
            class: _normalizeClass(["table-container flex flex-col", [
            filteredCampaigns.value && filteredCampaigns.value.length == 0
              ? 'empty'
              : 'filled',
          ]])
          }, [
            _createVNode(CampaignsTable, {
              campaigns: filteredCampaigns.value,
              isArchiveEnabled: isArchiveEnabled.value,
              isActiveFirst: activeFirstFromStore.value,
              isLoading: isLoading.value,
              rowsCount: _unref(rowsCount)(46, 20) * tableDisplaySettings.value.first,
              onSortTable: sortTable,
              onUpdateTable: updateCampaignsList
            }, null, 8, ["campaigns", "isArchiveEnabled", "isActiveFirst", "isLoading", "rowsCount"]),
            (
              filteredCampaigns.value && filteredCampaigns.value.length == 0 && !isLoading.value
            )
              ? (_openBlock(), _createBlock(EmptyTableMessage, { key: 0 }, {
                  text: _withCtx(() => [
                    _createTextVNode(" Создайте первую рекламную кампанию. "),
                    _hoisted_1,
                    _createTextVNode(" Для этого кликните на кнопку \"Создать РК\". ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode(_unref(Paginator), {
            first: tableDisplaySettings.value.first,
            "onUpdate:first": [
              _cache[2] || (_cache[2] = ($event: any) => ((tableDisplaySettings.value.first) = $event)),
              updateCampaignsList
            ],
            rows: 1,
            class: "s-paginator",
            totalRecords: _unref(store).campaignsPagesCount,
            template: "PrevPageLink CurrentPageReport NextPageLink",
            currentPageReportTemplate: "{first} из {totalRecords}"
          }, null, 8, ["first", "totalRecords"])
        ]),
        _: 1
      }, 8, ["is-denied"])
    ]),
    _: 1
  }))
}
}

})